<app-breadcrumb-mkt [title]="title" [routeBase]="route"/>




<div class="table-responsive" xmlns="http://www.w3.org/1999/html" xmlns="http://www.w3.org/1999/html">
  <table class="table">
    <thead>
    <tr>
      <th scope="col">#</th>
      <th class="w-25" scope="col">Nombre Descuento</th>
      <th class="w-10" scope="col">Nombre Categoría</th>
      <th scope="col">Valor</th>
      <th scope="col">Tipo</th>
      <th scope="col">Estado</th>
      <th scope="col">Destacada</th>
      <th scope="col">Fecha Vigencia</th>
      <th scope="col">Imágen</th>
      <th scope="col">Acciones</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let promocion of promotionsWeb; let i = index">
      <th scope="row">{{ i + 1 }}</th>
      <td>{{ promocion.nombre }}</td>
      <td>{{ promocion.categoria }}</td>
      <td>${{ promocion.precio }}</td>
      <td>{{ promocion.tipoPromocion }}</td>
      <td>{{ promocion.statusPromocion }}</td>
      <td>{{ promocion.isFeatured }}</td>
      <td>{{ moment(promocion.fechaExpiracion).format('DD-MM-YYYY') }}</td>
      <td><img width="100px" src="{{imgUrl}}{{ promocion.imagenPromocion }}" alt=""></td>
      <td>
        <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
          <button type="button" class="btn btn-primary" (click)="getAllDataPromotion(promocion.codPromocionSam)"
                  data-bs-toggle="modal" data-bs-target="#editPromcionWeb">
            <i class="bi bi-pencil"></i>
            Editar
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>


<div #modalUpdatePromocion class="modal fade" id="editPromcionWeb" tabindex="-1" aria-labelledby="editPromcionWeb" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Editar Promoción Web</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="col-md-7 col-lg-12">
          <form class="needs-validation" [formGroup]="formUpdatePromocion" novalidate (ngSubmit)="onSubmit()">
            <div class="row g-3">
              <div class="col-sm-12">
                <label for="codCategoria">Escoge la categoría <span class="text-body-secondary">(Esto definirá en que especialidad se muestra)</span></label>
                <select class="form-control"  formControlName="_id" name="categoria" id="codCategoria">
                  <option disabled selected value="">Escoge una categoría</option>
                  <option disabled  *ngFor="let item of categorias" [value]="item._id">
                    {{ item.categoria }}
                  </option>
                </select>
                <div style="color:red;" *ngIf="formUpdatePromocion.get('_id')?.errors?.['required']">La categoría es
                  obligatoria
                </div>
              </div>
              <div class="col-sm-6">
                <label for="firstName" class="form-label">Nombre Visible</label>
                <input [value]="nombre" formControlName="nombre" type="text" class="form-control"
                       id="firstName" placeholder=""
                       required/>
                <div style="color:red;" *ngIf="formUpdatePromocion.get('nombre')?.errors?.['required']">El nombre
                  es obligatorio
                </div>

              </div>

              <div class="col-sm-6">
                <label for="lastName" class="form-label">Tipo Promoción</label>
                <input [value]="tipoPromocion" formControlName="tipoPromocion" type="text" class="form-control"
                       id="lastName" placeholder=""
                       required>
                <div style="color:red;" *ngIf="formUpdatePromocion.get('tipoPromocion')?.errors?.['required']">El tipo
                  es obligatorio
                </div>

              </div>
              <div class="col-12">
                <label for="serviciosPromocion" class="form-label">Servicios de la promoción<span
                  class="text-body-secondary">(Son los items de la promoción)</span></label>
                <textarea [value]="servicios" formControlName="servicios" class="form-control" id="serviciosPromocion"
                          placeholder="Descripción de la promoción"></textarea>
                <div style="color:red;" *ngIf="formUpdatePromocion.get('servicios')?.errors?.['required']">Los servicios
                  son obligatorios
                </div>

              </div>

              <div class="col-12">
                <label for="descriptionPromocion" class="form-label">Descripción de la promoción<span
                  class="text-body-secondary">(Son los items de la promoción)</span></label>
                <textarea [value]="descripcion" formControlName="descripcion" class="form-control"
                          id="descriptionPromocion"
                          placeholder="Descripción de la promoción"></textarea>
                <div style="color:red;" *ngIf="formUpdatePromocion.get('descripcion')?.errors?.['required']">La
                  descripcion es obligatoria
                </div>

              </div>

              <div class="col-12">
                <label for="disclaimer" class="form-label">Disclaimer <span class="text-body-secondary">(Este texto siempre se verá rojo)</span></label>
                <textarea formControlName="disclaimer" [value]="disclaimer" class="form-control" id="disclaimer"
                          placeholder="¿Algo más que agregar?"></textarea>
                <div style="color:red;" *ngIf="formUpdatePromocion.get('disclaimer')?.errors?.['required']">Es
                  disclaimer es obligatorio
                </div>

              </div>

              <div class="col-md-3">
                <label for="statusPromotion" class="form-label">Estado Promoción</label>
                <select formControlName="statusPromocion" class="form-select" id="statusPromotion" required>
                  <option value="" disabled>Escoge...</option>
                  <option selected [value]="true">Activo</option>
                  <option [value]="false">Inactiva</option>
                </select>
                <div style="color:red;" *ngIf="formUpdatePromocion.get('statusPromocion')?.errors?.['required']">Es
                  status es
                  obligatorio
                </div>

              </div>

              <div class="col-md-3">
                <label for="date" class="form-label">Fecha Caducidad</label>
                <input formControlName="fechaExpiracion" type="date" id="date" class="form-control">
                <div style="color:red;" *ngIf="formUpdatePromocion.get('fechaExpiracion')?.errors?.['required']">La fecha es obligatoria </div>
              </div>


              <div class="col-md-3">
                <label for="date" class="form-label">¿Es destacado?</label>

                <select formControlName="isFeatured" id="isFeatured" class="form-control" >
                  <option    [value]="formUpdatePromocion">Escoge...</option>
                  <option selected  [value]="true">Si, es destacada</option>
                  <option  [value]="false">No, no es destacada</option>
                </select>
                <div style="color:red;" *ngIf="formUpdatePromocion.get('isFeatured')?.errors?.['required']">¿Es promoción destacada? </div>
              </div>


              <div class="col-md-3">
                <label for="valorPromocion" class="form-label">Valor</label>
                <input type="text" class="form-control" id="valorPromocion" placeholder="" [disabled]="precio"
                       [value]="'$' + precio" required>
                <div style="color:red;" *ngIf="formUpdatePromocion.get('precio')?.errors?.['required']">El valor
                  es obligatorio
                </div>

              </div>

              <hr class="my-4">

              <h4 class="mb-3">Multimedia</h4>

              <div class="my-3">
                <div class="form-check">
                  <label class="form-check-label" for="file">Imagen <span class="text-body-secondary">(Se recomienda imagen en formato 4x4 para mejorar su visibilidad y en formato .webp)</span></label>
                  <input #inputImagen type="file" id="file" class="form-control" (change)="capturarArchivo($event)">

                </div>

                <div class="input-group image" *ngIf="preview">
                  <img width="100%" [src]="preview" alt="">
                </div>
                <div class="input-group image" *ngIf="!preview && imagenPromocion">
                  <img width="100%" [src]="imgUrl+imagenPromocion" alt="">
                </div>
              </div>

              <div class="row gy-3"></div>

              <hr class="my-4">

              <div class="w-100 align-baseline" >
                <button (click)="sendAllData()" class=" btn btn-primary w-100" [disabled]="isLoading">
            <span class="text" *ngIf="!isLoading">
            Actualizar Promoción
            </span>
                  <div *ngIf="isLoading" class="spinner-border text-light " role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </button>
              </div>
            </div>
          </form>
        </div>

      </div>
    </div>
  </div>
</div>





<app-notifications/>




